import Aos from "aos";
import React, { useEffect } from "react";
import Slider from "react-slick";

const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow next" onClick={onClick}>
      <img src="/assets/services/next.svg" alt="" />
    </div>
  );
};

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow prev" onClick={onClick}>
      <img src="/assets/services/prev.svg" alt="" />
    </div>
  );
};

function HSlider({ data }) {
  useEffect(() => {
    Aos.init({
      duration: 1000, // animation duration in ms
      once: true // animate only once
    });
  }, []);
  const settings = {
    slidesToShow: 2.5,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    dots: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1
        }
      }
    ]
  };
  return (
    <>
      <Slider {...settings}>
        {data?.map((item, index) => (
          <div key={item._id || index}>
            <div
              data-aos="flip-up"
              className="relative max-w-[280px] w-full mr-auto md:ml-0 ml-auto pb-[12px]"
            >
              <img
                src={item.image || "/assets/services/fallback.png"}
                alt={item.title}
                className="w-full h-auto object-cover"
              />
              <button className="bg-[#FDD60D] rounded-[120px] py-[2px] font-sans font-[500] text-[20px] leading-[22px] text-[#263238] h-[53px] absolute bottom-[0px] left-[50%] translate-x-[-50%] w-full max-w-[247px]">
                {item.title}
              </button>
            </div>
          </div>
        ))}
        {/* <div>
                    <div data-aos="flip-up" className='relative max-w-[280px] w-full mr-auto md:ml-0 ml-auto pb-[12px]'>
                        <img src="/assets/services/img3.png" alt="" />
                        <button className='bg-[#FDD60D] rounded-[120px] py-[2px] font-sans font-[500] text-[20px] leading-[22px] text-[#263238] h-[53px] absolute bottom-[0px] left-[50%] translate-x-[-50%] w-full max-w-[247px]'>Mission</button>
                    </div>
                </div>
                <div>
                    <div data-aos="flip-up" className='relative max-w-[280px] w-full mr-auto md:ml-0 ml-auto pb-[12px]'>
                        <img src="/assets/services/img1.png" alt="" />
                        <button className='bg-[#FDD60D] rounded-[120px] py-[2px] font-sans font-[500] text-[20px] leading-[22px] text-[#263238] h-[53px] absolute bottom-[0px] left-[50%] translate-x-[-50%] w-full max-w-[247px]'>Workplace Behavior</button>
                    </div>
                </div>
                <div>
                    <div data-aos="flip-up" className='relative max-w-[280px] w-full mr-auto md:ml-0 ml-auto pb-[12px]'>
                        <img src="/assets/services/img2.png" alt="" />
                        <button className='bg-[#FDD60D] rounded-[120px] py-[2px] font-sans font-[500] text-[20px] leading-[22px] text-[#263238] h-[53px] absolute bottom-[0px] left-[50%] translate-x-[-50%] w-full max-w-[247px]'>Vision</button>
                    </div>
                </div>
                <div>
                    <div data-aos="flip-up" className='relative max-w-[280px] w-full mr-auto md:ml-0 ml-auto pb-[12px]'>
                        <img src="/assets/services/img3.png" alt="" />
                        <button className='bg-[#FDD60D] rounded-[120px] py-[2px] font-sans font-[500] text-[20px] leading-[22px] text-[#263238] h-[53px] absolute bottom-[0px] left-[50%] translate-x-[-50%] w-full max-w-[247px]'>Key Policies</button>
                    </div>
                </div>
                <div>
                    <div data-aos="flip-up" className='relative max-w-[280px] w-full mr-auto md:ml-0 ml-auto pb-[12px]'>
                        <img src="/assets/services/img1.png" alt="" />
                        <button className='bg-[#FDD60D] rounded-[120px] py-[2px] font-sans font-[500] text-[20px] leading-[22px] text-[#263238] h-[53px] absolute bottom-[0px] left-[50%] translate-x-[-50%] w-full max-w-[247px]'>Compliance</button>
                    </div>
                </div>
                <div>
                    <div data-aos="flip-up" className='relative max-w-[280px] w-full mr-auto md:ml-0 ml-auto pb-[12px]'>
                        <img src="/assets/services/img2.png" alt="" />
                        <button className='bg-[#FDD60D] rounded-[120px] py-[2px] font-sans font-[500] text-[20px] leading-[22px] text-[#263238] h-[53px] absolute bottom-[0px] left-[50%] translate-x-[-50%] w-full max-w-[247px]'>Ethics</button>
                    </div>
                </div> */}
      </Slider>
    </>
  );
}

export default HSlider;
